// extracted by mini-css-extract-plugin
module.exports = {"paper":"Alert_paper__EIc3U","modalBtn":"Alert_modalBtn__Z8CQ5","title":"Alert_title__mC8In","buttons":"Alert_buttons__F0KMK"};